import { defineMessages } from 'react-intl';

export const createTemplateMessages = defineMessages({
  createTemplateTitle: {
    defaultMessage: 'What do you want to create?',
    id: 'rm2Xf5pqgv',
    description: 'Heading on the create template entry screen',
  },
  createTemplateDescriptionLine1: {
    defaultMessage:
      'Upload an example, or describe the structure and purpose of what you want to create.',
    id: 'OWFE+OxnrP',
    description: 'First line of helper copy on the create template entry screen',
  },
  createTemplateDescriptionLine2: {
    defaultMessage:
      'We’ll create a reusable template that writes content that sounds just like you.',
    id: 'ZRZ9Pq0j/5',
    description: 'Second line of helper copy on the create template entry screen',
  },
  backToLibrary: {
    defaultMessage: 'Back to library',
    id: 'mhreNagAx3',
    description: 'Link label to return to the template library from create template',
  },
  createTemplatePlaceholder: {
    defaultMessage: 'I need a SOAP note with a problem based plan…',
    id: 'yjJ7RTsMj8',
    description: 'Placeholder in the create template chat input',
  },
  attachFiles: {
    defaultMessage: 'Attach files',
    id: 'QQ+2D4xvVt',
    description: 'Aria label for the attach files button on create template',
  },
  uploadExampleNotes: {
    defaultMessage: 'Upload example notes',
    id: 'uIk6L7qUFa',
    description: 'Tooltip when the user can still attach more example note files',
  },
  maximumFilesReached: {
    defaultMessage: 'Maximum 5 files reached',
    id: 'svZx9LyaR1',
    description: 'Tooltip when the create template file upload limit is reached',
  },
  duplicateFileTitle: {
    defaultMessage: 'Duplicate file',
    id: 'td+y15IEvm',
    description: 'Toast title when the user uploads the same file again',
  },
  duplicateFileDescription: {
    defaultMessage: 'This file has already been uploaded.',
    id: 'aGD8aWCZ7J',
    description: 'Toast body when the user uploads the same file again',
  },
  maximumFileLimitTitle: {
    defaultMessage: 'Maximum file limit reached',
    id: 'pBClavd+11',
    description: 'Toast title when create template file count exceeds the limit',
  },
  maximumFileLimitDescription: {
    defaultMessage: 'You can only upload up to {maxFiles} attachments.',
    id: 'HVciKBum08',
    description: 'Toast body when create template file count exceeds the limit',
  },
  unsupportedRequest: {
    defaultMessage: 'Sorry, Heidi can’t support this request',
    id: 'NvQpQzmydt',
    description: 'Toast when the create template request is not supported',
  },
  creatingTemplateCreationRecord: {
    defaultMessage: 'Error creating template creation record',
    id: 'SfgRutZ74h',
    description: 'Toast title when creating a template creation record fails',
  },
  unknownError: {
    defaultMessage: 'An unknown error occurred',
    id: 'uC6clS3UUA',
    description: 'Fallback error description for create template failures',
  },
  suggestions: {
    defaultMessage: 'Suggestions',
    id: 'qzKSczwSKa',
    description: 'Button label to open template prompt suggestions',
  },
  assemblyLoaderUnderstandingRequest: {
    defaultMessage: 'Understanding your request…',
    id: '7GRHnMmzt4',
    description: 'Status text while the assembly loader understands the request',
  },
  assemblyLoaderBuildingStructure: {
    defaultMessage: 'Building your structure…',
    id: 'ZdOoUSmad7',
    description: 'Status text while the assembly loader builds template structure',
  },
  assemblyLoaderDraftingExample: {
    defaultMessage: 'Drafting your example…',
    id: 'VU0dowL02s',
    description: 'Status text while the assembly loader drafts the example note',
  },
  assemblyLoaderComplete: {
    defaultMessage: 'Complete',
    id: 'GIRqHV62o9',
    description: 'Status text when the assembly loader finishes',
  },
});
